<template>
  <v-card>
    <v-card-title class="font-bold py-5" primary-title>
      <h3>
        <span>Phases</span>
      </h3>
      <br />
      <v-spacer></v-spacer>
      <v-icon @click="$emit('closeDialog')">mdi-close</v-icon>
    </v-card-title>

    <v-card-text class="pa-0">
      <formWrapper :validator="$v.form">
        <form class="form-box px-5">
          <v-alert
            v-if="globalServerErrors !== null"
            dense
            outlined
            type="error"
          >
            <p
              class="mb-0"
              v-for="globalErr in globalServerErrors"
              :key="globalErr"
            >
              {{ globalErr[0] }}
            </p>
          </v-alert>
          <v-row class="w-100">
            <v-col cols="4">
              <form-group name="phase" attribute="fields.phase">
                <template slot-scope="{ attrs, listeners }">
                  <v-select
                    :items="phases"
                    item-text="name"
                    item-value="id"
                    regular
                    clearable
                    return-object
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="form.id"
                  ></v-select>
                </template> </form-group
            ></v-col>
            <v-col cols="4" class="transparent-field">
              <v-switch
                v-model="form.visible"
                inset
                label="Visibility"
                :true-value="1"
                :false-value="0"
              ></v-switch>
            </v-col>
            <v-col cols="2" class="text-right">
              <v-btn
                @click="addPhase"
                color="primary"
                large
                class="mt-4 ml-auto"
                :disabled="!form.id || !form.visible"
                >Add</v-btn
              >
            </v-col>
            <v-col cols="2">
              <v-btn @click="handleSave" color="primary" class="mt-4" large
                >Save</v-btn
              >
            </v-col>
          </v-row>
        </form></formWrapper
      >
      <v-simple-table v-if="appTypePhases.length > 0" class="teams members">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">Priority</th>
              <th class="text-center">Name</th>
              <th class="text-center">Visibility</th>
              <th class="text-center">Intro</th>
              <th class="text-center">Hidden Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in appTypePhases" :key="item.name">
              <td class="text-center">{{ item.priority }}</td>
              <td class="text-center">
                <span v-if="Object.keys(item.id).length > 0">{{
                  item.id.name
                }}</span>
                <span v-else>{{ item.name }}</span>
              </td>
              <td class="table__cell text-center transparent-field">
                <v-checkbox
                  v-model="item.visible"
                  color="warning"
                  :true-value="1"
                  :false-value="0"
                  @change="phaseVisibility(item)"
                ></v-checkbox>
              </td>
              <td class="text-center">
                <template v-if="Object.keys(item.id).length > 0">
                  <read-more
                    more-str="more"
                    less-str="less"
                    :text="item.id.intro || '---'"
                    :max-chars="30"
                    class="mb-0 major-description m-b-0"
                  ></read-more>
                </template>
                <template v-else>
                  <read-more
                    more-str="more"
                    less-str="less"
                    :text="item.intro || '---'"
                    :max-chars="30"
                    class="mb-0 major-description m-b-0"
                  ></read-more>
                </template>
              </td>
              <td class="text-center">
                <template v-if="Object.keys(item.id).length > 0">
                  <read-more
                    more-str="more"
                    less-str="less"
                    :text="item.id.hidden_reason || '---'"
                    :max-chars="15"
                    class="mb-0 major-description m-b-0"
                  ></read-more>
                </template>
                <template v-else>
                  <read-more
                    more-str="more"
                    less-str="less"
                    :text="item.hidden_reason || '---'"
                    :max-chars="15"
                    class="mb-0 major-description m-b-0"
                  ></read-more>
                </template>
              </td>
              <!-- <td class="text-center">{{ item.email }}</td>
              <td class="text-center">{{ item.wellspring_order_id }}</td>
              <td class="text-center">
                <span v-if="item.reg_date">{{
                  item.reg_date | moment("Do,MMM' YYYY")
                }}</span>
                <span v-else>---</span>
              </td>
              <td class="text-center">{{ item.status }}</td> -->
              <td class="text-center">{{ item.status }}</td>
              -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <p v-else class="mb-0 pa-5 text-center">No phases yet</p>
    </v-card-text>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { UpdateData } from "@/helpers/apiMethods";
export default {
  props: {
    appTypePhases: {
      type: Array,
      default: () => {}
    },
    phases: {
      type: Array,
      default: () => {}
    },
    appData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {},
      globalServerErrors: null
    };
  },
  methods: {
    handleSave() {
      const formData = new FormData();
      formData.append("_method", "put");

      if (this.appTypePhases.length > 0) {
        this.appTypePhases.forEach((parent, index) => {
          Object.keys(parent).forEach(phase => {
            if (phase == "id") {
              if (Object.keys(parent.id).length > 0) {
                formData.append(`phases[${index}][${phase}]`, parent[phase].id);
              } else {
                formData.append(`phases[${index}][${phase}]`, parent.id);
              }
            } else if (
              phase == "intro" ||
              phase == "hidden_reason" ||
              phase == "name" ||
              phase == "priority"
            ) {
              return;
            } else {
              formData.append(`phases[${index}][${phase}]`, parent[phase]);
            }
          });
        });
      }
      UpdateData({
        reqName: `hr/application-types`,
        data: formData,
        id: this.appData.id
      })
        .then(() => {
          this.$emit("closeDialog");
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    phaseVisibility(item) {
      console.log(item);

      this.popUp().then(value => {
        if (!value.dismiss) {
          UpdateData({
            reqName: `hr/phases`,
            data: {
              visible: item.visible,
              _method: "PUT",
              visibility_only: "",
              application_type: this.appData.id
            },
            id: item.id
          })
            .then(() => {})
            .catch(() => {})
            .finally(() => {});
        }
      });
    },
    addPhase() {
      this.appTypePhases.push(this.form);
      this.reset();
    },
    reset() {
      this.form = {
        id: "",
        visible: 0
      };
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  },
  validations: {
    form: {
      id: { required }
    }
  }
};
</script>
